// extracted by mini-css-extract-plugin
module.exports = {"container":"TickList_container__uUQYG","listItem":"TickList_listItem__sLk_R","checkIcon":"TickList_checkIcon__6zgnm","container_small":"TickList_container_small__qcglf"};